export default __webpack_public_path__ + "static/logo-white-full-da863ae1472506de8ba7183e0e2dbb71.svg";